<template>
  <small class="recaptcha">
    This site is protected by reCAPTCHA and the Google
    <a
      target="_blank"
      href="https://policies.google.com/privacy"
      :class="{ light: onDark }"
      >Privacy Policy</a
    >
    and
    <a
      target="_blank"
      href="https://policies.google.com/terms"
      :class="{ light: onDark }"
      >Terms of Service</a
    >
    apply.
  </small>
</template>

<script>
export default {
  name: "Recaptcha",
  props: {
    onDark: Boolean
  }
};
</script>

<style scoped lang="scss">
.recaptcha {
  padding: 10px 0;
  display: block;
  a.light {
    color: white;
  }
}
</style>
